// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3MrwK","productName":"Table_productName__2SIG3"};